'use client'

import type { PropsWithChildren } from 'react'

import { cn } from '@mntn-dev/ui-utilities'
import { getTestProps } from '../../../utils/testing.ts'
import { PageHeaderControls } from './page-header-controls.tsx'
import { PageHeaderMain } from './page-header-main.tsx'
import { PageHeaderOverlineBreadcrumbs } from './page-header-overline-breadcrumbs.tsx'
import { PageHeaderOverlineDivider } from './page-header-overline-divider.tsx'
import { PageHeaderOverlineLink } from './page-header-overline-link.tsx'
import { PageHeaderOverline } from './page-header-overline.tsx'
import { PageHeaderSubtitle } from './page-header-subtitle.tsx'
import { PageHeaderTitleBreadcrumbs } from './page-header-title-breadcrumbs.tsx'
import { PageHeaderTitle } from './page-header-title.tsx'
import { PageHeaderProvider, usePageHeader } from './use-page-header.ts'
import type { UsePageHeaderProps } from './use-page-header.ts'

type PageHeaderProps = PropsWithChildren<
  UsePageHeaderProps & { className?: string }
>

const PageHeader = ({
  children,
  className,
  dataTestId,
  dataTrackingId,
  size = 'lg',
}: PageHeaderProps) => {
  const context = usePageHeader({ dataTestId, dataTrackingId, size })

  return (
    <PageHeaderProvider value={context}>
      <div
        {...getTestProps({
          dataTestId,
          dataTrackingId,
        })}
        className={cn(
          'flex w-full shrink-0 basis-0 flex-row items-center gap-6 self-stretch justify-between has-[.header-title]:mb-8',
          className
        )}
      >
        {children}
      </div>
    </PageHeaderProvider>
  )
}

const PageHeaderNamespace = Object.assign(PageHeader, {
  OverlineBreadcrumbs: PageHeaderOverlineBreadcrumbs,
  OverlineDivider: PageHeaderOverlineDivider,
  OverlineLink: PageHeaderOverlineLink,
  Subtitle: PageHeaderSubtitle,
  Title: PageHeaderTitle,
  TitleBreadcrumbs: PageHeaderTitleBreadcrumbs,
  Main: PageHeaderMain,
  Overline: PageHeaderOverline,
  Controls: PageHeaderControls,
})

export { PageHeaderNamespace as PageHeader, type PageHeaderProps }
